module.exports = __webpack_public_path__ + "static/media/fabio-mangione.0c111b04.jpg";